import type {CSSProperties} from 'react'
import type {GenericAsset} from '../../../../brand/lib/types/contentful'

function getSize({fields}: GenericAsset) {
  const image = fields.asset.fields.file.details?.image
  return {width: fields.width ?? image?.width, height: fields.height ?? image?.height}
}

/**
 * Unitless size custom properties for an image or video that has a desktop variant:
 *
 * - `--width` / `--height`: the default asset
 * - `--desktop-width` / `--desktop-height`: the desktop asset (the default's size when there is none)
 *
 * A media query can then pick the right pair, e.g.
 * `aspect-ratio: var(--desktop-width) / var(--desktop-height)`. This is needed because the
 * `<img>` and `<video>` only carry the default asset's `width` and `height` attributes, while the
 * browser picks the `<source>`. Values that Contentful doesn't provide are left out.
 */
export function getMediaSizeVars(fallback: GenericAsset, desktop?: GenericAsset): CSSProperties {
  const base = getSize(fallback)
  const large = desktop ? getSize(desktop) : base

  const vars: Record<string, string> = {}
  const set = (name: string, value: number | undefined) => {
    if (value !== undefined) vars[name] = String(value)
  }
  set('--width', base.width)
  set('--height', base.height)
  set('--desktop-width', large.width)
  set('--desktop-height', large.height)

  return vars
}
